export const siteConfig = {
  name: "Project Despair",
  terminalName: "PROJECT DESPAIR // PUBLIC WEBSITE",
  tagline: "To bring hope, we embrace despair.",
  infoTitle: "Small team, big hope.",
  statement: [
    "Project Despair is an indie game studio start up focused on original, unique 2D game experiences.",
    "We deliver great game concepts, mods or product that would bring hope to the world.",
  ],
  infoContact: {
    heading:
      "For business enquiries, collaboration proposals, or technical reports, we invite you to contact us directly.",
    cta: "CONTACT US",
    email: "contact@projectdespair.com",
    note: "All correspondence is reviewed. A response may be expected within several working days.",
  },
  team: [
    { name: "FRAZERIP", role: "PROJECT LEAD / PROGRAMMING" },
    { name: "SARAH", role: "DESIGNER / ARTIST" },
    { name: "ATOMG", role: "COMPOSER" },
  ],
  contact: {
    title: "Get in touch.",
    description:
      "Business enquiries, collaboration proposals, bug reports, and questions about our projects are each reviewed by a member of the team.",
    topics: ["GENERAL", "BUSINESS", "COLLABORATION", "BUG REPORT"],
    response: [
      { label: "TYPICAL", value: "2–5 DAYS" },
      { label: "LANGUAGE", value: "EN / 中文" },
      { label: "HOURS", value: "EVENINGS UTC+8" },
    ],
    notes: [
      {
        n: "01",
        text: "For bug reports, please state the title affected and the steps taken immediately beforehand. A screenshot is more useful than a description.",
      },
      {
        n: "02",
        text: "For collaboration proposals, please include the intended scope and timeline. We are a small team and decline work we cannot complete to standard.",
      },
      {
        n: "03",
        text: "For business and media enquiries, our asset pack containing key art, logos, and full-resolution screenshots is available on request.",
      },
    ],
  },
  capabilities: [
    {
      code: "01",
      title: "GAME DEVELOPMENT",
      description:
        "2D games built in Unity or Godot for web, desktop, and mobile — taken end to end, from prototype to release build.",
    },
    {
      code: "02",
      title: "MOD DEVELOPMENT",
      description:
        "Custom content for existing games — new characters, systems, and events, built to last and maintained after release.",
    },
    {
      code: "03",
      title: "SYSTEMS & UI DESIGN",
      description:
        "Mechanics and the screens that read them, designed together — custom keywords, relics, and branching events that stay legible under pressure.",
    },
    {
      code: "04",
      title: "ART & AUDIO DIRECTION",
      description:
        "Key art, card and character art, and a full original soundtrack — produced in-house and shipped with the build.",
    },
  ],
} as const;
